<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Thông tin xe"
      :required="required"
    >
      <div class="flex-row flex__left">
        <el-button class="btnPlain" @click="newCarAndDriverItems">
          <i class="el-icon-circle-plus"></i>
          &nbsp;Thêm xe
        </el-button>
      </div>
    </el-form-item>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="carsAndDrivers"
        v-if="carsAndDrivers && carsAndDrivers.length"
      >
        <el-table-column label="Xe" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="input-border__bottom input-border__radius__0 style-fullWidth"
              v-model="scope.row.carId"
              placeholder="Xe"
              size="medium"
              clearable
              filterable
              @change="carIdChanged(scope.row)"
            >
              <el-option
                v-for="car in displayCars(scope.row)"
                :key="car.id"
                :label="`${car.licencePlate} - ${car.manufacturer}`"
                :value="car.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Tài xế" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="input-border__bottom input-border__radius__0 style-fullWidth"
              v-model="scope.row.driverId"
              placeholder="Tài xế"
              size="medium"
              clearable
              filterable
            >
              <el-option
                v-for="driver in drivers"
                :key="driver.id"
                :label="driver.fullName"
                :value="driver.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="left" width="40">
          <template slot-scope="scope">
            <i
              class="el-icon-circle-close font-size__large color__red clickable"
              @click="remove(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import DialogAddDocs from "../../job/create-job/dialog-add-docs";
import hcCfgCarService from "../../../services/hcCfgCarService";
import constants from "../../../constants";
import hcCfgDriverService from "../../../services/hcCfgDriverService";
import h from "../../../services/h";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcDieuXeScheduleService from "../../../services/hcDieuXeScheduleService";

export default {
  name: "hc-dieuxe-cars-and-drivers",
  mixins: [handleRequestErrorMixin],
  components: { DialogAddDocs },
  props: ["deptId", "hcCaseMasterId", "required"],

  data() {
    return {
      carsAndDrivers: [],
      cars: [],
      drivers: []
    };
  },

  created() {
    this.loadDrivers();
    this.loadCars();
    if (this.hcCaseMasterId) this.loadHcDieuXeSchedules();
  },

  methods: {
    loadHcDieuXeSchedules() {
      return hcDieuXeScheduleService
        .findAllByHcCaseMasterId(this.hcCaseMasterId)
        .then(response => {
          h.each(response.data, hcDieuXeSchedule =>
            this.carsAndDrivers.push({
              carId: hcDieuXeSchedule.carId,
              driverId: hcDieuXeSchedule.driverId
            })
          );
        });
    },

    collectCarsAndDrivers() {
      return this.carsAndDrivers;
    },

    carIdChanged(carsAndDriversItem) {
      // if (!carsAndDriversItem.carId || carsAndDriversItem.driverId) return;
      let car = h.find(this.cars, item => carsAndDriversItem.carId === item.id);
      if (h.exists(this.drivers, item => item.id === car.driverId))
        carsAndDriversItem.driverId = car.driverId;
    },

    displayCars(carsAndDriversItem) {
      if(carsAndDriversItem && carsAndDriversItem.driverId) {
        return [...this.cars.filter(item => item.driverId === carsAndDriversItem.driverId),
        ...this.cars.filter(item => item.driverId !== carsAndDriversItem.driverId)];
      }
      return this.cars;
    },

    loadDrivers() {
      return hcCfgDriverService
        .findAll2(
          { deptId: this.deptId, status: constants.STATUS_.ACTIVE },
          { sort: "fullName,asc" }
        )
        .then(response => (this.drivers = response.data));
    },

    loadCars() {
      return hcCfgCarService
        .findAll(
          { deptId: this.deptId, status: constants.STATUS_.ACTIVE },
          { sort: "licencePlate,asc" }
        )
        .then(response => (this.cars = response.data));
    },

    newCarAndDriverItems() {
      this.carsAndDrivers.push({ carId: null, driverId: null });
    },

    remove(carsAndDriversItem) {
      this.carsAndDrivers.splice(
        this.carsAndDrivers.indexOf(carsAndDriversItem),
        1
      );
    },

    validateForm() {
      return new Promise(resolve => {
        if (
          !this.required &&
          (!this.carsAndDrivers || !this.carsAndDrivers.length)
        ) {
          resolve();
          return;
        }

        if (!this.carsAndDrivers || !this.carsAndDrivers.length) {
          this.$message.error("Thông tin xe & tài xế bắt buộc nhập");
          return;
        }

        let existInvalidForm = h.exists(
          this.carsAndDrivers,
          item => !item.carId || !item.driverId
        );

        if (existInvalidForm) {
          this.$message.error("Thông tin xe & tài xế bắt buộc nhập");
          return;
        }

        //validate duplicate thông tin xe
        let duplicatedCarItem = h.find(this.carsAndDrivers, item => {
          let count = h.count(
            this.carsAndDrivers,
            item2 => item2.carId === item.carId
          );
          return count >= 2;
        });

        if (duplicatedCarItem) {
          let car = h.find(
            this.cars,
            item => item.id === duplicatedCarItem.carId
          );
          this.$message.error(
            errorMessageFilter({
              errorCode: "hcDieuXe.duplicatedCar",
              params: [`${car.licencePlate} - ${car.manufacturer}`]
            })
          );
          return;
        }

        //validate duplicate thông tin tài xế
        let duplicatedDriverItem = h.find(this.carsAndDrivers, item => {
          let count = h.count(
            this.carsAndDrivers,
            item2 => item2.driverId === item.driverId
          );
          return count >= 2;
        });

        if (duplicatedDriverItem) {
          let driver = h.find(
            this.drivers,
            item => item.id === duplicatedDriverItem.driverId
          );
          this.$message.error(
            errorMessageFilter({
              errorCode: "hcDieuXe.duplicatedDriver",
              params: [driver.fullName]
            })
          );
          return;
        }

        resolve();
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-cars-and-drivers.vue